import _ from 'lodash'
import $ from 'jquery'
import TextFilter from 'scoreboard/reports/common/filter/text-filter'
import suggestionUrl from 'scoreboard/reports/common/filter/suggestion-url'
/**
 * Returns meta info for a particular text filter
 */
function meta(code, seedArgs = null) {
	let params = {
		nameCode: code,
		filterType: 'text',
		form: TextFilter,
		groupCode: 'admin.scorecards.metric.scoringType.basic'
	}
	if (seedArgs) {
		params.seed = suggestionUrl(...seedArgs)
	}
	return params
}

var TextFilterMeta = {
	label: meta('report.customReport.label', ['label', 'scorecard-item']),
	description: meta('report.customReport.description'),
	equation: meta('report.customReport.equation', ['equations', 'scorecard-item']),
	unit: meta('scorecards.node.metric.dataType.units', ['unit', 'scorecard-item'])
}

export default TextFilterMeta
export const textFilterMeta = meta
TextFilterMeta.__filename__ = 'reports/wizard/filter-meta/text-filter-meta.js'
